<template>
  <v-btn
    v-if="props.styling !== 'Cart'"
    :href="props.href"
    :to="props.to"
    @click="onClick"
    min-width="214"
    min-height="40"
    rounded
    variant="flat">
    <template v-slot:prepend>
      <v-icon :icon="icon" size="24" color="#55C0ED"></v-icon>
    </template>
    <div class="text">{{ text }}</div>
  </v-btn>
  <v-btn
    class="cart-btn"
    :href="props.href"
    :to="props.to"
    :ripple="false"
    @click="onClick"
    min-height="100"
    v-else>
    <div>
      <div class="badge-container">
        <img class="badge-bg" src="@/assets/HeaderButton_badge.svg" />
        <div class="badge-count">{{ count }}</div>
      </div>
      <div class="text">
        <v-icon :icon="icon" size="30"></v-icon> {{ text }}
      </div>
    </div>
  </v-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RouteLocationRaw } from 'vue-router';

const HeaderButtonStylingTypes = [
  'MyPage',
  'Signout',
  'Cart',
] as const;

type HeaderButtonStylingType = typeof HeaderButtonStylingTypes[number];

interface Emits {
  (e: 'click'): void;
}
const emits = defineEmits<Emits>();

interface Props {
  styling: HeaderButtonStylingType,
  count?: Number | undefined,
  href?: string | undefined,
  to?: RouteLocationRaw | undefined,
}

const props = withDefaults(defineProps<Props>(), {
  styling: 'MyPage',
});

/**
 * icon
 */
const icon = computed(() => {
  switch(props.styling) {
    case 'MyPage':
      return 'mdi-account-circle-outline'
    case 'Signout':
      return 'mdi-logout'
    case 'Cart':
      return 'mdi-cart-variant'
    default:
  }
  return undefined
})

/**
 * text
 */
const text = computed(() => {
  switch(props.styling) {
    case 'MyPage':
      return 'マイページ'
    case 'Signout':
      return 'ログアウト'
    case 'Cart':
      return 'カート'
    default:
  }
  return undefined
})

/**
 * クリックイベント発火
 */
const onClick = () => {
  emits('click');
}
</script>

<style lang="scss" scoped>
.text {
  font-weight: bold;
}
.cart-btn {
  &::v-deep(.badge-container) {
    position: relative;
    width: 45px;
    margin: auto;
  }
  &::v-deep(.badge-count) {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 45px;
    height: 45px;
    top: 0;
    font-weight: bold;
    color: white;
  }
  &::v-deep(.v-btn__overlay) {
    display: none;
  }
}
</style>
